import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../../../context/AppContext";
import ProductDetails from "../../../../user/pages/standard/pages/shop/components/ProductDetails";
import { AccountActivationData } from "../network/api/AccountActivationData";

export default function Activation({ confirmedID }) {
    const navigate = useNavigate();
    const { appData } = useAppContext();

    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setError(null);
        setIsLoading(true);
        if (!confirmedID) {
            navigate("/account-activation");
            return;
        }
        const fetchData = async () => {
            try {
                const response = await AccountActivationData({ user_id: confirmedID, app_id: appData.id });
                if (response.status === "success") {
                    if (response.data.status === "active") {
                        setError("Account already activated. You can now log in.");
                        setTimeout(() => {
                            window.location.href = "/login";
                        }, 1000);
                    }
                } else {
                    setError(response.message);
                }
                setIsLoading(false);

            } catch (error) {
                setError("An error occurred while processing your request.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [confirmedID, appData, navigate]);



    return (
        <div className="container py-5 d-flex flex-column  justify-content-between">
            {isLoading && (
                <div className="d-flex justify-content-center align-items-center vh-100">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            {error && (
                <>
                    <div className="alert alert-danger text-center" role="alert">
                        {error}


                    </div>
                    <button className="btn btn-primary mt-3" onClick={() => window.location.reload()}>
                        <i className="fa fa-refresh me-2"></i>Reload
                    </button>
                </>

            )}
            {!isLoading && !error && (
                <div className="card shadow-lg" >
                    <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                        <h3 className="mb-0 text-white">Account Activation</h3>

                        <button className="btn btn-light btn-sm text-primary" onClick={() => navigate(-1)}>
                            <i className="fa fa-arrow-left me-2"></i>
                            Back</button>
                    </div>

                    <div className="row ">
                        <h4 className="text-center fw-bold my-3">Welcome! Your account is pending activation.</h4>
                        <p className="text-center mb-4">To activate your account, complete the process below. <strong>{appData?.name}</strong></p>

                        <ProductDetails slug={"onboarding"} loggedInUserData={{ user: { userId: confirmedID } }} lockedQuantity={10} />
                    </div>
                </div>
            )}

            <footer className="text-center mt-5 small text-muted">
                &copy; {appData?.name} {new Date().getFullYear()} &nbsp; | &nbsp; <Link to="/legal" className="text-muted">Legal</Link>
                &nbsp; | &nbsp; <Link to="/help" className="text-muted">Help</Link>
            </footer>
        </div>
    );
}
